import React, { Component } from 'react'
import { Row, Col, Icon, Carousel } from 'antd';
import MediaQuery from 'react-responsive'
import '../icons/icons.css'

const content = [
  {
    title: 'Duurzame arbeidsrelaties',
    text: 'Via unlocQed bereik je zonder onbewuste aannames meer kandidaten. Die niet per se dringend op zoek zijn naar die beter passende baan.',
    icon: 'win'
  },
  {
    title: 'Via privacy bij design',
    text: 'Bepaal jij de mate waarin je wel of niet openlijk in contact komt met bedrijven i.p.v. dat cookies dit voor jouw doen. “UnlocQ and take control!”',
    icon: 'profile'
  },
  {
    title: 'Meer zuurstof',
    text: 'Bij iedere nieuwe arbeidsrelatie of ingekochte vacature via unlocQed zullen wij bomen in Nederland én het buitenland planten.',
    icon: 'tree'
  }
]


class Information extends Component {

  state = {
    slidesToShow: 1
  }

  componentDidMount = () => {
    this.getSlidesToShow()
    window.addEventListener('resize',  (event) => {
      this.getSlidesToShow()
    });
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', (event) => {
      this.getSlidesToShow()
    });
  }

  getSlidesToShow = () => {
    const height = window.innerWidth
    let { slidesToShow } = this.state
    let new_slidesToShow;

    if (height < 768) {
      new_slidesToShow =  1
    } else {
      new_slidesToShow = 3
    }

    if (slidesToShow !== new_slidesToShow) {
      this.setState({slidesToShow: new_slidesToShow})
    }
  }

    render() {

      const {t} = this.props;
      const { slidesToShow } = this.state

        return (
          <Row style={{marginTop: -80, marginBottom: -80}}>
            <div className="title-container">
              <h1 className="information-title">Waarom unlocQed het ideale job-matching platform is:</h1>
            </div>
            <div style={{minHeight: '300px'}} className="information-block">

            <MediaQuery minDeviceWidth={481}>
              <Carousel
                dots={false}
                slidesToShow={3}

              >
                {content.map( item => (
                  <div style={{ margin: 10 }}>
                    <div className="info-container">
                      <div className={`icon flaticon-${item.icon}`} />
                      <div className="info-title">{item.title}</div>
                      <div className="info-description">{item.text}</div>
                    </div>
                  </div>
                  ))}
              </Carousel>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={480}>
              <Carousel
                dots={true}
                slidesToShow={1}
                dotPosition={'bottom'}
                slidesToScroll={1}
                style={{backgroundColor: 'blue'}}
              >
                {content.map( item => (
                  <div style={{ margin: 10, backgroundColor: 'yellow' }}>
                    <div className="info-container">
                      <div className={`icon flaticon-${item.icon}`} />
                      <div className="info-title">{item.title}</div>
                      <div className="info-description">{item.text}</div>
                    </div>
                  </div>
                  ))}
              </Carousel>
            </MediaQuery>

            </div>
          </Row>
        )
    }
}

export default Information
